import { axios } from "@sdk/axios";
import type {
  ApcPeriodQueryRequest,
  ApcPeriodQueryResponse,
  AtolAraPackRequest,
  LicensableBookingsQueryRequest,
  LicensableBookingsQueryResponse,
} from "./atol-report.models";

export class AtolReportServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
    this.atol.configure(config);
  }

  constructor(protected config: { basePath: string; token: string }) {
    this.atol = new AtolReportApi(config);
  }

  atol!: AtolReportApi;
}

class AtolReportApi {
  constructor(protected config: { basePath: string; token: string }) {}

  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }

  licensableBookingsQuery = (body: LicensableBookingsQueryRequest) =>
    axios
      .post<LicensableBookingsQueryResponse>(
        `${this.config.basePath}/reports/atol/licensable-bookings/query`,
        body,
        { headers: { Authorization: this.config.token } }
      )
      .then((r) => r.data);

  downloadAraPack = (body: AtolAraPackRequest) =>
    axios.post<Blob>(
      `${this.config.basePath}/reports/atol/ara-pack`,
      body,
      {
        headers: { Authorization: this.config.token },
        responseType: "blob",
      }
    );

  apcPeriodQuery = (body: ApcPeriodQueryRequest) =>
    axios
      .post<ApcPeriodQueryResponse>(
        `${this.config.basePath}/reports/atol/apc/query`,
        body,
        { headers: { Authorization: this.config.token } }
      )
      .then((r) => r.data);
}
